import { Link } from "react-router-dom";
import { Image as ImageIcon, Network, ArrowUpRight } from "lucide-react";
import { SubjectBadge } from "@/components/SubjectBadge";

const slug = (w) => w.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");

export const TermCard = ({ term, index }) => (
  <Link
    to={`/termine/${term.id}`}
    data-testid={`term-card-${slug(term.word)}`}
    className="ink-box ink-press rise group flex flex-col rounded-2xl bg-white p-5"
    style={{ animationDelay: `${Math.min(index, 12) * 45}ms` }}
  >
    <div className="mb-3 flex items-start justify-between gap-3">
      <SubjectBadge subject={term.subject} />
      <ArrowUpRight className="h-5 w-5 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </div>
    <h3 className="font-display text-2xl font-bold leading-tight">{term.word}</h3>
    <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-neutral-700">{term.definition}</p>
    <div className="mt-auto flex gap-2 pt-4 text-xs font-bold">
      {term.comic_status === "ready" && (
        <span className="flex items-center gap-1 rounded-full bg-[var(--sun)] px-2 py-1"><ImageIcon className="h-3.5 w-3.5" /> Fumetto</span>
      )}
      {term.map_status === "ready" && (
        <span className="flex items-center gap-1 rounded-full bg-[var(--sky)] px-2 py-1 text-white"><Network className="h-3.5 w-3.5" /> Mappa</span>
      )}
    </div>
  </Link>
);
